import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//路由列表
let routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   redirect: {name: 'Home'}
  // },
];

//引入路由
//龙烟
// import {longyanRouter} from '@/components/longyan/router'
// routes = [...routes, ...longyanRouter];

//今天国际产业园
//import {jintianguojiRouter} from '@/components/jintianguoji/router'
//routes = [...routes, ...jintianguojiRouter];

//厦烟
import {xiayanRouter} from '@/components/xiayan/router'
routes = [...routes, ...xiayanRouter];


//
let router = new Router({
  routes: routes
});

router.afterEach((to, from, next) => {  
  //
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js